export default "__VITE_ASSET__BoBtT9wW__"